import Stack from "@mui/material/Stack";
import React from "react";
import CallsInPast from "./CallsInPast";
import CallsToday from "./CallsToday";

const name = "CallsList";

interface CallsListProps {
    type: "today" | "past"
    calls: any[]
}

const CallsList: React.FC<CallsListProps> = ({ calls, type }) => {
    return (<Stack sx={{ maxHeight: 120, overflowY: "auto" }}>
        {type === "today" && calls.map((c, index: number) => (
            <CallsToday key={index + c.call_id} call={c} />))}
        {type === "past" && calls.map((c, index: number) => (
            <CallsInPast key={index + c.call_id} call={c} />))}
    </Stack>)
}

CallsList.displayName = name;

export default React.memo(CallsList);